import { createAction, props } from '@ngrx/store';
import { Toast } from './toast.state';

/**
 * Show a message without an action
 */
export const showToastAction = createAction('[Toasts] Show', props<Toast>());

/**
 * Remove a toast
 */
export const removeToastAction = createAction('[Toasts] Remove');
